import {
    EQ_REQUEST_START,
    EQ_REQUEST_SUCCESS,
    EQ_REQUEST_NO_PERMISSION,
    EQ_REQUEST_FAILED,

    EQ_OPEN_UPDATE_FORM,
    EQ_DELETE,
    EQ_UPDATE,
    EQ_INSERT,
    EQ_UPDATE_FIELD,

    EQ_ORDER_OPEN_UPDATE_FORM,
    EQ_ORDER_UPDATE_FIELD,
    EQ_ORDER_UPDATE,
    EQ_ORDER_DELETE,

    EQ_CATEGORY_ADD,

    EQ_ITEM_OPEN_UPDATE_FORM,
    EQ_ITEM_UPDATE_FIELD,
    EQ_ITEM_UPDATE
} from '../actions/EquipmentActions';


const initialState = {
    status: 'Initialize'
};

export default function EquipmentReducer(state = initialState, action) {

    if (!action) {
        return state;
    }

    switch (action.type) {

        case EQ_REQUEST_START:
            return {
                ...state, status: 'request', country: action.country, date: action.date,
                product: action.product,
                platform: action.platform
            };
        case EQ_REQUEST_SUCCESS:
            return {...state, status: 'success', data: action.data};
        case EQ_REQUEST_NO_PERMISSION:
            return {...state, status: 'no_permission'};
        case EQ_REQUEST_FAILED:
            return {...state, status: 'error'};
        case EQ_OPEN_UPDATE_FORM:
            return {...state,errorUpdate:false,itemInEdit:action.item};
        case EQ_UPDATE_FIELD:
            var updatedItems = {...state.itemInEdit};
            updatedItems[action.field] = action.value;
            return {...state,errorUpdate:false, itemInEdit: updatedItems};
        case EQ_INSERT:
            let tmp2 = state.data;

            var modifiedItems = [];
            var modifiedData = [];
            for (var index in state.data.equip){

                if(state.data.equip[index].groupId !== action.item.groupId) {
                    modifiedItems.push(state.data.equip[index] );
                }
                else {
                    for( var index2 in state.data.equip[index].data) {
                        modifiedData.push(state.data.equip[index].data[index2] );
                    }

                    modifiedData.push(action.item);

                    modifiedItems.push({groupId: state.data.equip[index].groupId, groupName: state.data.equip[index].groupName, data: modifiedData});
                }
            }

            tmp2.equip = modifiedItems;

            return {...state,data:tmp2,errorUpdate:false};
        case EQ_UPDATE:
            let tmp1 = state.data;

            var updatedEquip = [];
            var updatedData = [];
            for (var index in state.data.equip){

                if(state.data.equip[index].groupId !== action.item.groupId) {
                    updatedEquip.push(state.data.equip[index] );
                }
                else {
                    for(var index2 in state.data.equip[index].data) {
                        if (state.data.equip[index].data[index2].id === action.item.id){

                            updatedData.push(action.item);
                        }
                        else{
                            updatedData.push(state.data.equip[index].data[index2]);

                        }
                    }

                    updatedEquip.push({groupId: state.data.equip[index].groupId, groupName: state.data.equip[index].groupName, data: updatedData})
                }
            }
            tmp1.equip = updatedEquip;

            return {...state,data:tmp1,errorUpdate:false};

        case EQ_DELETE:
            let tmpDel = state.data;

            let modifiedEq = [];
            var updatedDelData = [];

            for (var index in state.data.equip){

                if(state.data.equip[index].groupId !== action.item.groupId) {
                    modifiedEq.push(state.data.equip[index] );
                }
                else {

                    for(var index2 in state.data.equip[index].data) {
                        if (state.data.equip[index].data[index2].id !== action.item.id){

                            updatedDelData.push(state.data.equip[index].data[index2]);
                        }
                    }

                    modifiedEq.push({groupId: state.data.equip[index].groupId, groupName: state.data.equip[index].groupName, data: updatedDelData})
                }
            }

            tmpDel.equip = modifiedEq;

            return {...state,data:tmpDel,errorUpdate:false};

        case EQ_ORDER_OPEN_UPDATE_FORM:
            return {...state,errorUpdate:false,itemOrderInEdit:action.item};

        case EQ_ORDER_UPDATE_FIELD:
            var updatedItems = {...state.itemOrderInEdit};
            updatedItems[action.field] = action.value;
            return {...state,errorUpdate:false, itemOrderInEdit: updatedItems};

        case EQ_ORDER_UPDATE:
            let tmp3 = state.data;

            var updatedEquipOrder = [];
            for (var index in state.data.equipOrders){

                if (state.data.equipOrders[index].id === action.item.id){

                    updatedEquipOrder.push(action.item);
                }
                else{
                    updatedEquipOrder.push(state.data.equipOrders[index]);

                }
            }
            tmp3.equipOrders = updatedEquipOrder;

            return {...state,data:tmp3,errorUpdate:false};

        case EQ_ORDER_DELETE:

            let modifiedEqOrder = {equipOrders: [], equip: state.data.equip, equipStore: state.data.equipStore, equipStoreManagers: state.data.equipStoreManagers};

            //console.log(modifiedCustomers)

            for (var index in state.data.equipOrders){

                if (state.data.equipOrders[index].id !== action.id){

                    modifiedEqOrder.equipOrders.push({...state.data.equipOrders[index] });
                }
            }

            return {...state,data:modifiedEqOrder,errorUpdate:false};

        case EQ_CATEGORY_ADD:

            let modifiedEqCat = {equip: [], equipOrders: state.data.equipOrders, equipStore: state.data.equipStore};

            //console.log(modifiedCustomers)

            /*let maxId = 0;

            for (var index in state.data.equip){

                maxId = state.data.equip[index].groupId;

                modifiedEqCat.equip.push({...state.data.equip[index] });
            }*/

            for (var index in state.data.equip){
                modifiedEqCat.equip.push({...state.data.equip[index] });
            }

            let newCat = {groupId: action.id, groupName: action.value, data: []};
            modifiedEqCat.equip.push({...newCat });

            return {...state,data:modifiedEqCat,errorUpdate:false};

        case EQ_ITEM_OPEN_UPDATE_FORM:
            return {...state,errorUpdate:false,itemEquipInEdit:action.item};


        case EQ_ITEM_UPDATE_FIELD:
            var updatedItems = {...state.itemEquipInEdit};
            updatedItems[action.field] = action.value;
            return {...state,errorUpdate:false, itemEquipInEdit: updatedItems};

        case EQ_ITEM_UPDATE:
            let tmp4 = state.data;

            var updatedEquipOrder = [];
            for (var index in state.data.equipStore){

                if (state.data.equipStore[index].serial === action.item.serial){

                    updatedEquipOrder.push(action.item);
                }
                else{
                    updatedEquipOrder.push(state.data.equipStore[index]);

                }
            }
            tmp4.equipStore = updatedEquipOrder;

            return {...state,data:tmp4,errorUpdate:false};

        default:
            return state;
    }
}